import { render, staticRenderFns } from "./LeaveCreate.vue?vue&type=template&id=15eb5d1e"
import script from "./LeaveCreate.vue?vue&type=script&lang=js"
export * from "./LeaveCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports